import type { QueryClient } from "@tanstack/react-query";

import { getPlatformUserPackagesByPackageId } from "api/methods";

/**
 * Invalidate every cached read of a package after a redemption, whatever membership, active and
 * location variant it was read under, so the wallet never offers the pre-redemption quantity again.
 */
export const invalidateRedeemedPackage = (queryClient: QueryClient, packageId: string) =>
  queryClient.invalidateQueries(getPlatformUserPackagesByPackageId.filters({ packageId }));
